import React from 'react';
import { useTranslation } from 'react-i18next';
import {
	EndorsementData,
	withEndorsementContext,
} from '../../../context/EndorsementProvider';
import {
	BREADCRUMB__INVOICE,
	BREADCRUMB__INVOICES,
} from '../../../data/labelsAndMessages';
import { useRouteMatch } from '../../../util/useRouteMatch';
import BreadcrumbsContainer, { Breadcrumb } from '../../BreadcrumbsContainer';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import {
	ExposureRoutes,
	ROUTES as ENDORSEMENT_ROUTES,
} from '../Sidebar/EndorsementSidebar';

interface Props {
	endorsementData: EndorsementData;
}

const Breadcrumbs = (props: Props) => {
	const { t } = useTranslation();
	const { policy, endorsementUpdateObj } = props.endorsementData;

	const routeMatch = useRouteMatch(
		Object.keys(ENDORSEMENT_ROUTES).map(
			(key) => ENDORSEMENT_ROUTES[key as keyof ExposureRoutes],
		),
	);
	const params = routeMatch?.params;

	if (!policy) {
		return <LargeCenterSpinner />;
	}

	const { policyholderLocator, locator } = policy;

	const breadcrumbs: Breadcrumb[] = [
		{ href: `/policyholder/${policyholderLocator}`, text: 'Policyholder' },
		{ href: `/policy/${locator}`, text: `Policy ${locator}` },
		{
			href: `/policy/${locator}/endorsements/${endorsementUpdateObj.locator}`,
			text: `${t('endorsement.singular.upper')} ${
				endorsementUpdateObj.locator
			}`,
		},
	];

	// prepare invoices breadcrumbs
	if (
		[ENDORSEMENT_ROUTES.INVOICE, ENDORSEMENT_ROUTES.INVOICES].includes(
			routeMatch?.pattern?.path,
		)
	) {
		breadcrumbs.push({
			href: ENDORSEMENT_ROUTES.INVOICES.replace(
				':policyId',
				policy.locator,
			).replace(':endorsementId', endorsementUpdateObj.locator),
			text: BREADCRUMB__INVOICES(),
		});

		if (routeMatch?.pattern?.path === ENDORSEMENT_ROUTES.INVOICE) {
			breadcrumbs.push({
				href: ENDORSEMENT_ROUTES.INVOICE.replace(':policyId', policy.locator)
					.replace(':endorsementId', endorsementUpdateObj.locator)
					.replace(':invoiceId', params.invoiceId),
				text: BREADCRUMB__INVOICE(params.invoiceId),
			});
		}
	}

	return <BreadcrumbsContainer breadcrumbs={breadcrumbs} />;
};

export default withEndorsementContext<Props>(Breadcrumbs);
